if (!customElements.get('lac-lightwrap')) {
  customElements.define('lac-lightwrap', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-lw-tab]')];
      this.panels = [...this.querySelectorAll('[data-lw-panel]')];
      if (!this.tabs.length) return;
      this.querySelector('[data-lw-tabs]').hidden = false;
      this.select(this.tabs[0].dataset.lwTab);
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-lw-tab]');
        if (tab && this.contains(tab)) this.select(tab.dataset.lwTab);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-lw-panel]');
        if (panel) this.select(panel.dataset.lwPanel);
      });
    }
    select(id) {
      this.tabs.forEach(tab => tab.setAttribute('aria-pressed', String(tab.dataset.lwTab === id)));
      this.panels.forEach(panel => { panel.hidden = panel.dataset.lwPanel !== id; });
    }
  });
}
